var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("flexbox", { staticClass: "project-cell" }, [
    _vm.drag
      ? _c("div", { staticClass: "drag-handle" }, [_vm._v("⋮⋮")])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "project-cell__icon",
        style: { backgroundColor: _vm.iconColor },
      },
      [_c("i", { class: _vm.iconClass })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "project-cell__label text-one-line" }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
    ]),
    _vm._v(" "),
    _vm.collect
      ? _c("i", {
          staticClass: "wk wk-focus-on project-cell__collect",
          class: { "is-collect": _vm.isCollect },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.$emit("collect")
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }